<template>
    <section class="summary-panel">
        <hh-error-display :error="error" />
        <div class="summary-panel__content">
            <property-summary />
        </div>
    </section>
</template>

<script>

import Vuex from 'vuex'

import PropertySummary from './property-summary'

export default {

    props: {
        error: {
            type: String,
            default: null,
        },
    },

    computed: {

        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {?PropertyAsJson}
             */
            property: stateStore => stateStore.property,
        }),
    },

    components: {
        PropertySummary,
    },
}

</script>

<style lang="scss">

.summary-panel {
    @include element('content') {
        @include bp-min-mid {
            max-width: 75%;
        }

        @include bp-min-wide {
            max-width: 65%;
        }
    }
}

</style>
